// Auth mutations
export const RETRIEVE_TOKEN = 'RETRIEVE_TOKEN';
export const DESTROY_TOKEN = 'DESTROY_TOKEN';

// Add other mutation types here as needed
// For example:
// export const SET_USER = 'SET_USER';
// export const CLEAR_USER = 'CLEAR_USER';
